import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d2d1335"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-blue-500" }
const _hoisted_2 = {
  key: 0,
  class: "tooltip"
}
const _hoisted_3 = { class: "ring rounded absolute z-10 p-1 bg-white mt-1 min-w-full ticket-details" }
const _hoisted_4 = { class: "flex flex-col w-auto gap-y-1 text-center text-black" }
const _hoisted_5 = ["src"]

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ExampleTicketTooltip',
  props: {
    image: String
},
  setup(__props) {



const isTooltipVisible = ref(false);

function showTooltip() {
    isTooltipVisible.value = true;
}

function hideTooltip() {
    isTooltipVisible.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "tooltip-container",
    onMouseover: showTooltip,
    onMouseleave: hideTooltip
  }, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t('messages.ticketManagement.formList.field.exampleTicket')), 1),
    (isTooltipVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: __props.image,
                alt: "",
                class: "h-auto max-w-full"
              }, null, 8, _hoisted_5)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 32))
}
}

})